export function setToken(token) {
    localStorage.setItem('token', token);
}

export function getToken() {
    return localStorage.getItem('token');
}

export function removeToken() {
    localStorage.removeItem('token');
}

export function isLoggedIn() {
    return !!getToken();
}

export function setLoginId(loginId) {
    localStorage.setItem('loginId', loginId);
}

export function setUsername(username){
    localStorage.setItem('username', username);
}

export function removeLoginId(){
    localStorage.removeItem('loginId');
}

export function getLoginId(){
    return localStorage.getItem('loginId');
}

const API_URL = process.env.REACT_APP_API_URL;

export const checkAdminStatus = async () => {
    try {
        const token = localStorage.getItem('token');
        if (!token) return false;

        const response = await fetch(`${API_URL}/admin/check-status`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.ok;
    } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
};